import React, { Component } from 'react';
import moment from 'moment';
import {
  Row,
  Col,
  Table,
  Container,
  Button,
  TabPane,
  TabContent,
  UncontrolledTooltip,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import ChevronDownIcon from 'mdi-react/ChevronDownIcon';
import MagnifyIcon from 'mdi-react/MagnifyIcon';
import { toast } from 'react-toastify';
import { Link, withRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';
import fileDownload from 'js-file-download';
import { Parser } from 'json2csv';
import CheckIcon from 'mdi-react/CheckIcon';
import CloseIcon from 'mdi-react/CloseIcon';
import DotsHorizontalIcon from 'mdi-react/DotsHorizontalIcon';
import DragVerticalIcon from 'mdi-react/DragVerticalIcon';
import DownloadIcon from 'mdi-react/DownloadIcon';
import EditOutlineIcon from 'mdi-react/EditOutlineIcon';
import DeleteOutlineIcon from 'mdi-react/DeleteOutlineIcon';
import UserAddOutlineIcon from 'mdi-react/UserAddOutlineIcon';
import ImageOutlineIcon from 'mdi-react/ImageOutlineIcon';
import exportToExcelFile from '../../util/xlsx';
import Api from '../../util/api';
import Loading from '../../shared/components/custom/Loading';
import Pagination from '../../shared/components/pagination/Pagination';
import DeleteModal from '../../shared/components/custom/DeleteModal';
import SortDirection from '../../shared/components/custom/SortDirection';
import NavTab from '../../shared/components/custom/NavTab';
import t, { partial } from '../../util/translation/translation';
import AppSponsor from './components/AppSponsor';
import { convertImageToBlob } from '../../util/image-functions';
import LinkModal from '../../shared/components/custom/LinkModal';
import ShareModal from '../../shared/components/custom/ShareModal';
import GroupForm from './components/GroupForm';
import LevelInformation from './components/LevelInformation';
import { capitalizeFirstLetter } from '../../util/functions';
import AlertModal from '../../shared/components/custom/AlertModal';
import SquareIconButton from '../../shared/components/custom/SquareIconButton';
import FormCard from '../../shared/components/custom/FormCard';
import useConfig from '../../util/useConfig';
import GoalServiceSponsor from './components/GoalServiceSponsor';
import config from '../../config';
import WebsiteSponsor from './components/WebsiteSponsor';
import CompanyStatisticsOverview from './components/CompanyStatisticsOverview';
import SponsorViewsCard from './components/SponsorViewsCard';
import SponsorViewsClubSettings from './components/SponsorViewsClubSettings';
import CompanyCategoryBreakdown from './components/CompanyCategoryBreakdown';
import CompanyLevelBreakdown from './components/CompanyLevelBreakdown';

const s = partial('shared');
const p = partial('CompanyListPage');
const ct = partial('Category');
const a = partial('AlertModal');
const sv = partial('SponsorViews');

const SettingType = {
  GROUP: 'group',
  LEVEL: 'level',
};

class CompanyListPage extends Component {
  constructor() {
    super();
    this.state = {
      companies: {
        total: 0,
        current_page: '1',
        per_page: '25',
        page: 1,
        data: [],
      },
      order: 'name',
      reverse: false,
      searchText: '',
      searchIn: '',
      loadingCompanies: false,
      loadingSponsor: false,
      linkModalVisible: false,
      modalVisible: false,
      selectedCompanyID: null,
      loadingSettings: false,
      clubProfile: null,
      isAppVisible: true,
      isSponsor: true,
      tab: '',
      deleteModal: {
        visible: false,
        settingID: null,
        type: 'level',
      },
      groupModal: {
        visible: false,
        groupState: null,
        type: '',
      },
      levelModal: {
        visible: false,
        levelState: null,
        type: '',
      },
      settingState: false,
      groups: [],
      levels: [],
      selectedCompanies: [],
      companyFilter: 'all',
      // Viewers per company in the latest month, for clubs that collect them
      sponsorViews: { enabled: false, month: null, byCompany: {} },
    };
  }

  componentDidMount() {
    this.getGroupsAndLevels();
    this.getSponsorViews();
  }

  getSponsorViews = async () => {
    try {
      const status = await Api.companies.sponsorViews.getStatus();
      if (!status?.enabled) {
        // Also after a super-admin switched it off on this page
        this.setState({
          sponsorViews: { enabled: false, month: null, byCompany: {} },
        });
        return;
      }
      const result = await Api.companies.sponsorViews.getCompanies();
      this.setState({
        sponsorViews: {
          enabled: true,
          month: result.viewersMonth,
          byCompany: Object.fromEntries(
            result.companies.map((row) => [row.companyId, row])
          ),
        },
      });
    } catch {
      // Without the numbers the list is shown as before
    }
  };

  onChangePage = (pager) => {
    if (
      pager.pageSize !== this.state.companies.per_page ||
      pager.currentPage !== this.state.companies.current_page
    ) {
      this.getCompanies(pager.currentPage, pager.pageSize);
    }
  };

  addDeleteCompaniesFromGroupOrLevel = async (fieldValue, type) => {
    const { selectedCompanies } = this.state;
    try {
      const selectedCompaniesIds = selectedCompanies.map((x) => x.id);
      let resSelectedCompanies = [];
      if (type === SettingType.GROUP) {
        resSelectedCompanies =
          await Api.companies.getCompaniesForGroup(fieldValue);
      } else {
        resSelectedCompanies = await Api.club.getCompaniesForLevel(fieldValue);
      }
      const initiallySelected = resSelectedCompanies.map((x) => x.id);
      const toDelete = initiallySelected.filter(
        (x) => !selectedCompaniesIds.includes(x)
      );
      const toAdd = selectedCompaniesIds.filter(
        (x) => !initiallySelected.includes(x)
      );
      const promises = [];
      if (toDelete.length) {
        promises.push(
          type === SettingType.GROUP
            ? Api.club.deleteCompaniesFromGroup({
                companyId: toDelete,
                fieldValue,
              })
            : Api.club.deleteCompaniesFromLevel({
                companyId: toDelete,
                fieldValue,
              })
        );
      }
      if (toAdd.length) {
        promises.push(
          type === SettingType.GROUP
            ? Api.club.addCompaniesToGroup({ companyId: toAdd, fieldValue })
            : Api.club.addCompaniesToLevel({ companyId: toAdd, fieldValue })
        );
      }
      await Promise.all(promises);
    } catch (err) {
      toast.error(err || `${s('400')}`);
    }
  };

  handleModalTypeChangeToEdit = () => {
    const { levelModal, groupModal } = this.state;
    const key = levelModal.visible ? SettingType.LEVEL : SettingType.GROUP;
    if (key === SettingType.LEVEL) {
      this.setState({ levelModal: { ...levelModal, type: 'edit' } });
    } else {
      this.setState({ groupModal: { ...groupModal, type: 'edit' } });
    }
  };

  onSubmitSetting = async (values) => {
    const { levelModal, groupModal } = this.state;
    const key = levelModal.visible ? SettingType.LEVEL : SettingType.GROUP;
    const type = key === SettingType.LEVEL ? levelModal.type : groupModal.type;
    this.setState(
      {
        loadingSettings: true,
      },
      async () => {
        try {
          if (type === 'edit') {
            await this.addDeleteCompaniesFromGroupOrLevel(
              key === SettingType.GROUP
                ? groupModal?.groupState.value
                : levelModal?.levelState.value,
              key
            );
          }

          if (type === 'create') {
            const payload = {
              key: capitalizeFirstLetter(key),
              value: values.name,
            };

            await Api.club.createSetting(payload);
            toast.success(`${p(`${key}Created`)}`);
            this.getGroupsAndLevels();
          } else if (type === 'edit') {
            const payload = {
              id:
                key === SettingType.LEVEL
                  ? levelModal?.levelState?.id
                  : groupModal?.groupState.id,
              value: values.name,
              key: capitalizeFirstLetter(key),
            };
            await Api.club.editSetting(payload);
            toast.success(`${p(`${key}Updated`)}`);
            this.getGroupsAndLevels();
          }
        } catch (err) {
          toast.error(err || `${s('somethingWentWrong')}`);
          this.getGroupsAndLevels();
        } finally {
          this.setState({
            loadingSettings: false,
            levelModal: { visible: false, levelState: null, type: '' },
            groupModal: { visible: false, groupState: null, type: '' },
          });
        }
      }
    );
  };

  getCompanies = (
    page = this.state.companies.current_page,
    pageSize = this.state.companies.per_page
  ) => {
    this.setState({ loadingCompanies: true }, async () => {
      try {
        const resCompanies = await Api.companies.getCompanies(
          pageSize,
          page,
          this.state.searchText,
          this.state.order,
          this.state.reverse,
          this.state.isAppVisible,
          this.state.isSponsor,
          this.state.searchIn
        );
        this.setState({
          companies: {
            ...this.state.companies,
            data: resCompanies.data.data,
            total: resCompanies.data.total,
          },
          loadingCompanies: false,
        });
      } catch (err) {
        this.setState({ loadingCompanies: false });
        toast.error(err || `${p('companiesFetchingERROR')}`);
      }
    });
  };

  hasImageThenConvert = async (image) => {
    const hasImage = Array.isArray(image) && image.length === 1;
    if (!hasImage) {
      return '';
    }
    if (image[0].size === undefined) {
      return image[0];
    }
    try {
      return {
        ...image[0],
        preview: await convertImageToBlob(image[0]),
      };
    } catch (err) {
      toast.error(err || `${s('imageUploadingERROR')}`);
      throw err;
    }
  };

  handleModal = (state, companyID) => {
    this.setState({ modalVisible: state, selectedCompanyID: companyID });
  };

  handleLinkModal = (state, companyID) => {
    this.setState({ linkModalVisible: state, selectedCompanyID: companyID });
  };

  displayCategories = (company) => {
    const categories =
      company?.companyCategories
        ?.map((x) => {
          try {
            return ct(x);
          } catch (e) {
            toast.error(e || s('somethingWentWrong'));
            return x;
          }
        })
        ?.join(', ') || '-';
    return (
      <>
        <div id={`tooltip-${company.id}`}>
          {' '}
          {`${categories.length > 50 ? `${categories.substring(0, 20)}...` : categories}`}
        </div>
        {categories.length > 50 && (
          <UncontrolledTooltip
            placement="left"
            target={`tooltip-${company.id}`}
          >
            {categories}
          </UncontrolledTooltip>
        )}
      </>
    );
  };
  handleSettingDeleteModal = (settingID = null, type = 'level') => {
    this.setState({ deleteModal: { visible: !!settingID, settingID, type } });
  };

  listCompanies = () => {
    const { history } = this.props;
    return this.state.companies.data.map((company) => (
      <tr key={`Company-${company.id}`}>
        <td className="table-stack__primary">
          <div className="flex alignItems-center" style={{ gap: 8 }}>
            {company?.images?.companyImage ? (
              <img
                className="company__profile__avatar"
                src={company?.images?.companyImage}
                alt="logo"
              />
            ) : (
              <span className="company__profile__avatar_placeholder">
                {company?.name[0]?.toUpperCase()}
              </span>
            )}
            <Link to={`/companies/edit/${company.id}?tab=1`}>
              {company.name}
            </Link>
          </div>
        </td>
        <td data-label={s('employees')}>{company.employeeCount}</td>
        <td data-label={`${s('level')} / ${s('category')}`}>
          <div>{company.companyLevel || '-'}</div>
          <small className="text-muted">
            {this.displayCategories(company)}
          </small>
        </td>
        <td data-label={`${s('sponsor')} / ${s('visibleInApp')}`}>
          <div className="status-dot-group">
            <span
              className={`status-dot ${company.isSponsor ? 'status-dot--on' : 'status-dot--off'}`}
              title={s('sponsor')}
            >
              {company.isSponsor ? <CheckIcon /> : <CloseIcon />}
            </span>
            <span
              className={`status-dot ${company.isAppVisible ? 'status-dot--on' : 'status-dot--off'}`}
              title={s('visibleInApp')}
            >
              {company.isAppVisible ? <CheckIcon /> : <CloseIcon />}
            </span>
          </div>
        </td>
        {this.state.sponsorViews.enabled && (
          <td
            data-label={sv('viewersColumn', {
              month: this.state.sponsorViews.month
                ? moment(`${this.state.sponsorViews.month}-01`).format(
                    'MMM YYYY'
                  )
                : '',
            })}
          >
            {Number(
              this.state.sponsorViews.byCompany[company.id]?.viewers || 0
            ).toLocaleString()}
          </td>
        )}
        {this.state.sponsorViews.enabled && (
          <td data-label={sv('clicksColumn')}>
            {Number(
              this.state.sponsorViews.byCompany[company.id]?.clicks || 0
            ).toLocaleString()}
          </td>
        )}
        <td className="table-stack__actions">
          <div className="icon-actions">
            <SquareIconButton
              icon={<EditOutlineIcon />}
              onClick={() =>
                history.push(`/companies/edit/${company.id}?tab=1`)
              }
              title={s('edit')}
              id={`edit-${company.id}`}
            />
            <SquareIconButton
              icon={<UserAddOutlineIcon />}
              onClick={() =>
                history.push(`/companies/edit/${company.id}?tab=2`)
              }
              title={p('addContactPerson')}
              id={`add-${company.id}`}
            />
            <SquareIconButton
              icon={<ImageOutlineIcon />}
              onClick={() =>
                history.push(`/companies/edit/${company.id}?tab=3`)
              }
              title={p('sponsorMaterial')}
              id={`sponsor-${company.id}`}
            />
            <SquareIconButton
              icon={<DeleteOutlineIcon />}
              onClick={() => this.handleModal(true, company.id)}
              title={s('delete')}
              tone="danger"
              id={`delete-${company.id}`}
            />
          </div>
        </td>
      </tr>
    ));
  };

  getGroupsAndLevels = async () => {
    try {
      const [levels, groups] = await Promise.all([
        Api.club.getLevels(),
        Api.club.getGroups(),
      ]);

      let groupCompaniesCount = {};
      let levelCompaniesCount = {};
      if (groups?.length) {
        groupCompaniesCount =
          await Api.companies.getCompaniesCountForGroups(groups);
      }
      if (levels?.length) {
        levelCompaniesCount =
          await Api.companies.getCompaniesCountForLevels(levels);
      }
      const levelsWithCount = levels.map((level) => {
        return {
          ...level,
          count:
            levelCompaniesCount?.find((l) => l.value === level.value)?.count ??
            0,
        };
      });
      const groupsWithCount = groups.map((group) => {
        return {
          ...group,
          count:
            groupCompaniesCount?.find((g) => g.value === group.value)?.count ??
            0,
        };
      });

      this.setState({ groups: groupsWithCount, levels: levelsWithCount });
    } catch (err) {
      toast.error(err || `${s('400')}`);
    }
  };

  handleSort = (order) => {
    const reverse =
      this.state.order === order ? !this.state.reverse : this.state.reverse;
    this.setState({ order, reverse }, () => {
      this.getCompanies();
    });
  };

  handleInput = (e) => {
    this.setState({ searchText: e.target.value });
  };

  handleSearch = (e) => {
    if (e.key === 'Enter') {
      this.getCompanies();
    }
  };

  updateSelectedCompanies = (companiesSelected) => {
    this.setState({ selectedCompanies: companiesSelected });
  };

  exportCompanies = () => {
    this.setState({ loadingCompanies: true }, async () => {
      try {
        const resCompanies = await Api.companies.getClubCompanies();
        const fields = [
          { label: 'Name', value: 'name' },
          { label: 'VAT', value: 'organization_number' },
          { label: 'Phone', value: 'phone' },
          { label: 'email', value: 'email' },
          { label: 'Level', value: 'companyLevel' },
          {
            label: `${t('CompanyForm.companyCategory')}`,
            value: 'companyCategories',
          },
          { label: `${s('sponsor')}`, value: 'sponsor' },
          { label: `${s('visibleInApp')}`, value: 'visibleInApp' },
        ];
        const transformedCompanyData = resCompanies.map((company) => ({
          ...company,
          companyCategories: company?.companyCategories?.join(', ') || '',
          sponsor: company?.isSponsor ? s('yes') : s('no'),
          visibleInApp: company?.isAppVisible ? s('visible') : s('inVisible'),
        }));
        const json2csvParser = new Parser({ fields });
        const csv = json2csvParser.parse(transformedCompanyData);
        fileDownload(`\uFEFF${csv}`, `${p('exportCompany')}.csv`);
        this.setState({ loadingCompanies: false });
      } catch (err) {
        this.setState({ loadingCompanies: false });
        toast.error(err || `${p('listExportingERROR')}'!'`);
      }
    });
  };

  exportCompaniesXLSX = () => {
    this.setState({ loadingCompanies: true }, async () => {
      try {
        const resCompanies = await Api.companies.getClubCompanies();
        const data = resCompanies.map((i) => {
          const result = {};
          result[`${s('companyName')}`] = i?.name;
          result[`${s('organizationNumber')}`] = i?.organization_number;
          result[`${s('phone')}`] = i?.phone;
          result[`${s('email')}`] = i?.email;
          result[`${s('level')}`] = i?.companyLevel;
          result[`${t('CompanyForm.companyCategory')}`] =
            i?.companyCategories?.join(', ') || '';
          result[`${s('sponsor')}`] = i?.isSponsor ? s('yes') : s('no');
          result[`${s('visibleInApp')}`] = i?.isAppVisible
            ? s('visible')
            : s('inVisible');
          return result;
        });
        exportToExcelFile(data, `${p('exportCompany')}`);
        this.setState({ loadingCompanies: false });
      } catch (err) {
        this.setState({ loadingCompanies: false });
        toast.error(err || `${p('listExportingERROR')}'!'`);
      }
    });
  };

  exportEmployees = () => {
    this.setState({ loadingCompanies: true }, async () => {
      try {
        const { data: resEmployees } =
          await Api.companies.getAllCompaniesEmployees();

        const { data: companiesGroups } =
          await Api.companies.getAllGroupsForAllCompaniesByFieldType('Group');

        const resCompanies = await Api.companies.getCompanies(
          this.state.companies?.total || 50,
          1,
          this.state.searchText,
          this.state.order,
          this.state.reverse,
          this.state.isAppVisible,
          this.state.isSponsor,
          this.state.searchIn
        );
        const resEmployeesWithMetaData = resEmployees.map((emp) => {
          const groups = companiesGroups[emp.company.id] || [];
          return {
            ...emp,
            level:
              resCompanies.data?.data?.find(
                (comp) => comp.companyId === emp.company.id
              )?.companyLevel || '-- --',
            group: Array.isArray(groups) ? groups.join(',') : groups || '-- --',
            visibleInApp: resCompanies.data?.data?.find(
              (comp) => comp.companyId === emp.company.id
            )?.isAppVisible,
          };
        });
        const mappedEmployees = resEmployeesWithMetaData
          .map((emp) => {
            let primaryContact = '';
            let vip = '';

            if (emp.status === 'PRIMARY_AND_VIP') {
              primaryContact = 'true';
              vip = 'true';
            } else if (emp.status === 'PRIMARY_CONTACT') {
              primaryContact = 'true';
            } else if (emp.status === 'VIP') {
              vip = 'true';
            } else {
              primaryContact = '';
              vip = '';
            }
            return {
              compName: emp.company.generalName,
              vat: emp.company.organization_number,
              firstName: emp.firstName,
              lastName: emp.lastName,
              email: emp.email,
              phone: emp.phone,
              connected: !!emp.userId,
              primaryContact,
              vip,
              level: emp.level,
              group: emp.group,
              partnerVisibility: emp?.visibleCompany
                ? s('visible')
                : s('inVisible'),
              visibleInApp: emp?.visibleInApp ? s('visible') : s('inVisible'),
            };
          })
          .sort((first, second) =>
            first.compName.localeCompare(second.compName)
          );
        const fields = [
          { label: s('companyName'), value: 'compName' },
          { label: 'VAT', value: 'vat' },
          { label: t('AddEmployee.firstName'), value: 'firstName' },
          { label: t('AddEmployee.lastName'), value: 'lastName' },
          { label: s('email'), value: 'email' },
          { label: s('phone'), value: 'phone' },
          { label: p('connected'), value: 'connected' },
          { label: t('AddEmployee.primaryContact'), value: 'primaryContact' },
          { label: 'vip', value: 'vip' },
          { label: s('level'), value: 'level' },
          { label: s('group'), value: 'group' },
          {
            label: t('Reports.visibleForPartners'),
            value: 'partnerVisibility',
          },
          { label: s('visibleInApp'), value: 'visibleInApp' },
        ];
        const json2csvParser = new Parser({ fields });
        const csv = json2csvParser.parse(mappedEmployees);
        fileDownload(`\uFEFF${csv}`, `${p('exportEmployees')}.csv`);
        this.setState({ loadingCompanies: false });
      } catch (err) {
        this.setState({ loadingCompanies: false });
        toast.error(err || `${p('listExportingERROR')}'!'`);
      }
    });
  };

  exportEmployeesXLSX = () => {
    this.setState({ loadingCompanies: true }, async () => {
      try {
        const { data: resEmployees } =
          await Api.companies.getAllCompaniesEmployees();
        const { data: companiesGroups } =
          await Api.companies.getAllGroupsForAllCompaniesByFieldType('Group');
        const resCompanies = await Api.companies.getCompanies(
          this.state.companies?.total || 50,
          1,
          this.state.searchText,
          this.state.order,
          this.state.reverse,
          this.state.isAppVisible,
          this.state.isSponsor,
          this.state.searchIn
        );
        const resEmployeesWithMetaData = resEmployees.map((emp) => {
          const groups = companiesGroups[emp.company.id] || [];
          return {
            ...emp,
            level:
              resCompanies.data?.data?.find(
                (comp) => comp.companyId === emp.company.id
              )?.companyLevel || '-- --',
            group: Array.isArray(groups) ? groups.join(',') : groups || '-- --',
            visibleInApp: resCompanies.data?.data?.find(
              (comp) => comp.companyId === emp.company.id
            )?.isAppVisible,
          };
        });

        const data = resEmployeesWithMetaData.map((emp) => {
          let primaryContact = '';
          let vip = '';

          if (emp.status === 'PRIMARY_AND_VIP') {
            primaryContact = 'true';
            vip = 'true';
          } else if (emp.status === 'PRIMARY_CONTACT') {
            primaryContact = 'true';
          } else if (emp.status === 'VIP') {
            vip = 'true';
          } else {
            primaryContact = '';
            vip = '';
          }
          const result = {};
          result[`${s('companyName')}`] = emp?.company.generalName;
          result['VAT'] = emp?.company.organization_number;
          result[`${t('AddEmployee.firstName')}`] = emp?.firstName;
          result[`${t('AddEmployee.lastName')}`] = emp?.lastName;
          result[`${s('email')}`] = emp?.email;
          result[`${s('phone')}`] = emp?.phone;
          result[`${p('connected')}`] = emp?.userId;
          result[`${t('AddEmployee.primaryContact')}`] = primaryContact;
          result['VIP'] = vip;
          result[`${s('level')}`] = emp?.level;
          result[`${s('group')}`] = emp?.group;
          result[`${t('Reports.visibleForPartners')}`] = emp?.visibleCompany
            ? s('visible')
            : s('inVisible');
          result[`${s('visibleInApp')}`] = emp?.visibleInApp
            ? s('visible')
            : s('inVisible');
          return result;
        });

        exportToExcelFile(data, `${p('exportEmployees')}`);
        this.setState({ loadingCompanies: false });
      } catch (err) {
        this.setState({ loadingCompanies: false });
        toast.error(err || `${p('listExportingERROR')}'!'`);
      }
    });
  };

  removeCompany = (companyID) => {
    this.setState({ loadingCompanies: true }, async () => {
      try {
        await Api.companies.unlinkCompany({
          companyId: companyID,
          deleteComment: '',
        });
        this.setState({ modalVisible: false });
        this.getCompanies();
      } catch (err) {
        this.setState({ modalVisible: false, loadingCompanies: false });
        toast.error(err || `${p('companyDeletingERROR')}'!'`);
        this.getCompanies();
      }
    });
  };

  categoryOnDragEnd = ({ destination, source }) => {
    if (!destination) {
      return;
    }

    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }
    const draggedLevel = this.state.levels[source.index];
    const newLevels = [...this.state.levels];
    newLevels.splice(source.index, 1);
    newLevels.splice(destination.index, 0, draggedLevel);
    this.setState({ levels: newLevels, loadingSettings: true }, async () => {
      const order = newLevels.map((level, index) => ({
        id: level.id,
        order: index,
      }));
      try {
        await Api.club.updateSettingsOrder({ settingOrders: order });
        toast.success(`${p('categoryOrderUpdated')}`);
        this.setState({ loadingSettings: false });
      } catch (err) {
        this.setState({ loadingSettings: false });
        toast.error(err || `${p('orderUpdatingERROR')}`);
      }
    });
  };

  handleSettingViewClick = (setting, type) => {
    if (type === SettingType.GROUP) {
      this.setState({
        groupModal: { visible: true, groupState: setting, type: 'view' },
      });
    }
  };

  handleSettingEditClick = (setting, type) => {
    if (type === SettingType.LEVEL) {
      this.setState({
        levelModal: { visible: true, levelState: setting, type: 'edit' },
      });
    } else {
      this.setState({
        groupModal: { visible: true, groupState: setting, type: 'edit' },
      });
    }
  };

  renderGroups = () => {
    const { groups } = this.state;
    return groups.map((group) => (
      <tr key={`groups-${group.id}`}>
        <td className="table-stack__primary">
          <button
            type="button"
            className="link-button font-weight-500"
            onClick={() =>
              this.setState({
                groupModal: { visible: true, groupState: group, type: 'edit' },
              })
            }
          >
            {group.value}
          </button>
        </td>
        <td data-label={s('companies')}>
          {this.renderCompanyCount(group.count)}
        </td>
        <td className="table-stack__actions">
          <div className="icon-actions justify-content-end">
            <SquareIconButton
              icon={<EditOutlineIcon />}
              onClick={() =>
                this.handleSettingEditClick(group, SettingType.GROUP)
              }
              title={s('edit')}
              id={`edit-${group.id}`}
            />
            <SquareIconButton
              icon={<DeleteOutlineIcon />}
              onClick={() =>
                this.handleSettingDeleteModal(group.id, SettingType.GROUP)
              }
              title={s('delete')}
              tone="danger"
              id={`delete-${group.id}`}
            />
          </div>
        </td>
      </tr>
    ));
  };

  renderCompanyCount = (count) => (
    <span className={`qb-chip${count ? ' setting-count--on' : ''}`}>
      {count ?? 0}
    </span>
  );

  renderLevels = () => {
    const { levels } = this.state;
    return levels.map((level, index) => (
      <Draggable
        key={`level-${level.id}`}
        draggableId={`level-${level.id}`}
        index={index}
        isDragDisabled={!!this.state.settingState}
      >
        {(provided, snapshot) => (
          <tr
            ref={provided.innerRef}
            {...provided.draggableProps}
            className={`settings-drag-row${
              snapshot.isDragging ? ' rbdnd-dragging' : ''
            }`}
            key={`level-${level.id}`}
          >
            <td className="table-col--drag" {...provided.dragHandleProps}>
              <DragVerticalIcon size={18} />
            </td>
            <td className="table-stack__primary">
              <span className="settings-order">{index + 1}</span>
              <button
                type="button"
                className="link-button font-weight-500"
                onClick={() =>
                  this.setState({
                    levelModal: {
                      visible: true,
                      levelState: level,
                      type: 'edit',
                    },
                  })
                }
              >
                {level.value}
              </button>
            </td>
            <td data-label={s('companies')}>
              {this.renderCompanyCount(level.count)}
            </td>
            <td className="table-stack__actions">
              <div className="icon-actions justify-content-end">
                <SquareIconButton
                  icon={<EditOutlineIcon />}
                  onClick={() =>
                    this.setState({
                      levelModal: {
                        visible: true,
                        levelState: level,
                        type: 'edit',
                      },
                    })
                  }
                  title={s('edit')}
                  id={`edit-${level.id}`}
                />
                <SquareIconButton
                  icon={<DeleteOutlineIcon />}
                  onClick={() =>
                    this.handleSettingDeleteModal(level.id, 'level')
                  }
                  title={s('delete')}
                  tone="danger"
                  id={`delete-${level.id}`}
                />
              </div>
            </td>
          </tr>
        )}
      </Draggable>
    ));
  };

  selectCompayFilter = (companyFilter, isSponsor, isAppVisible) => {
    if (this.state.companyFilter !== companyFilter) {
      this.setState({ companyFilter, isSponsor, isAppVisible });
      this.getCompanies();
    }
  };

  closeSettingModal = (type) => {
    if (type === SettingType.GROUP) {
      this.setState({
        groupModal: { visible: false, groupState: null, type: '' },
      });
    } else if (type === SettingType.LEVEL) {
      this.setState({
        levelModal: { visible: false, levelState: null, type: '' },
      });
    }
  };
  deleteSetting = async () => {
    try {
      this.setState({ loadingSettings: true });
      await Api.club.deleteSetting(this.state.deleteModal.settingID);
      await this.getGroupsAndLevels();
      toast.success(p(`${this.state.deleteModal.type}Deleted`));
    } catch (e) {
      toast.error(e || s('somethingWentWrong'));
    } finally {
      this.handleSettingDeleteModal(false);
      this.setState({ loadingSettings: false });
    }
  };
  render() {
    const {
      order,
      reverse,
      tab,
      levelModal,
      loadingCompanies,
      loadingSettings,
      loadingSponsor,
      groupModal,
    } = this.state;
    const isLoading = loadingCompanies || loadingSettings || loadingSponsor;
    const availableTabs = [
      `${s('companies')}`,
      `${s('levels')}/${s('groups')}`,
      `${s('Statistics')}`,
      // Super-admins also see it while collection is off, to switch it on
      (this.state.sponsorViews.enabled || this.props.isSuperAdmin) &&
        sv('clubTabTitle'),
    ].filter(Boolean);
    return (
      <Container>
        <Loading loading={isLoading} />
        <NavTab
          activeTab={tab}
          tabs={availableTabs}
          setTab={(activeTab) => this.setState({ tab: activeTab })}
        />
        <DeleteModal
          type={s(`the${this.state.deleteModal.type}Small`)}
          visible={this.state.deleteModal.visible}
          handleModal={this.handleSettingDeleteModal}
          modalAction={this.deleteSetting}
        />
        <LinkModal
          visible={this.state.linkModalVisible}
          handleModal={this.handleLinkModal}
          modalAction={this.linkCompany}
        />
        <AlertModal
          visible={this.state.modalVisible}
          handleModal={this.handleModal}
          modalType="DELETION"
          message={a('companyDeleteMsg')}
          subText={s('companyRemoveMsg')}
          modalAction={() => this.removeCompany(this.state.selectedCompanyID)}
        />
        <TabContent activeTab={this.state.tab}>
          <TabPane tabId="1">
            <CompanyStatisticsOverview />
            <FormCard
              title={
                <>
                  <div className="form-card__switch d-none d-md-inline-flex">
                    <button
                      type="button"
                      className={`form-card__switch-btn${
                        this.state.companyFilter === 'all' ? ' active' : ''
                      }`}
                      onClick={() => this.selectCompayFilter('all', true, true)}
                    >
                      {s('all')}
                    </button>
                    <button
                      type="button"
                      className={`form-card__switch-btn${
                        this.state.companyFilter === 'notVisible'
                          ? ' active'
                          : ''
                      }`}
                      onClick={() =>
                        this.selectCompayFilter('notVisible', true, false)
                      }
                    >
                      {s('notVisible')}
                    </button>
                    <button
                      type="button"
                      className={`form-card__switch-btn${
                        this.state.companyFilter === 'notSponsor'
                          ? ' active'
                          : ''
                      }`}
                      onClick={() =>
                        this.selectCompayFilter('notSponsor', false, true)
                      }
                    >
                      {s('notSponsor')}
                    </button>
                  </div>
                  <span className="d-md-none">
                    {this.state.companyFilter === 'all' && s('all')}
                    {this.state.companyFilter === 'notVisible' &&
                      s('notVisible')}
                    {this.state.companyFilter === 'notSponsor' &&
                      s('notSponsor')}
                  </span>
                </>
              }
              actions={
                <>
                  <div
                    className="d-none d-md-flex align-items-center"
                    style={{ gap: 10 }}
                  >
                    <div className="form noWrap">
                      <div className="form__form-group products-list__search">
                        <input
                          placeholder={p('searchForCompany')}
                          value={this.state.searchText}
                          onChange={this.handleInput}
                          onKeyPress={this.handleSearch}
                          name="search"
                        />
                        <MagnifyIcon />
                      </div>
                    </div>
                    <UncontrolledDropdown>
                      <DropdownToggle
                        className="icon icon--right mb-0"
                        outline
                        size="sm"
                      >
                        <DownloadIcon /> {s('export')} <ChevronDownIcon />
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem
                          key="exp2"
                          onClick={this.exportCompaniesXLSX}
                        >
                          {p('exportCompanies')} (XLSX)
                        </DropdownItem>
                        <DropdownItem
                          key="exp4"
                          onClick={this.exportEmployeesXLSX}
                        >
                          {p('exportEmployees')} (XLSX)
                        </DropdownItem>
                        <DropdownItem key="exp1" onClick={this.exportCompanies}>
                          {p('exportCompanies')} (CSV)
                        </DropdownItem>
                        <DropdownItem key="exp3" onClick={this.exportEmployees}>
                          {p('exportEmployees')} (CSV)
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                    <Link to="/companies/create?tab=1">
                      <Button color="primary" size="sm" className="mb-0">
                        {p('createCompany')}
                      </Button>
                    </Link>
                  </div>
                  <div
                    className="d-flex d-md-none align-items-center"
                    style={{ gap: 8 }}
                  >
                    <div className="form noWrap">
                      <div className="form__form-group products-list__search">
                        <input
                          placeholder={p('searchForCompany')}
                          value={this.state.searchText}
                          onChange={this.handleInput}
                          onKeyPress={this.handleSearch}
                          name="search"
                        />
                      </div>
                    </div>
                    <UncontrolledDropdown>
                      <DropdownToggle
                        tag="button"
                        type="button"
                        className="square-icon-btn"
                        caret={false}
                      >
                        <DotsHorizontalIcon />
                      </DropdownToggle>
                      <DropdownMenu right className="dropdown-menu--modern">
                        <DropdownItem
                          active={this.state.companyFilter === 'all'}
                          onClick={() =>
                            this.selectCompayFilter('all', true, true)
                          }
                        >
                          {s('all')}
                        </DropdownItem>
                        <DropdownItem
                          active={this.state.companyFilter === 'notVisible'}
                          onClick={() =>
                            this.selectCompayFilter('notVisible', true, false)
                          }
                        >
                          {s('notVisible')}
                        </DropdownItem>
                        <DropdownItem
                          active={this.state.companyFilter === 'notSponsor'}
                          onClick={() =>
                            this.selectCompayFilter('notSponsor', false, true)
                          }
                        >
                          {s('notSponsor')}
                        </DropdownItem>
                        <DropdownItem divider />
                        <DropdownItem onClick={this.exportCompaniesXLSX}>
                          {p('exportCompanies')} (XLSX)
                        </DropdownItem>
                        <DropdownItem onClick={this.exportEmployeesXLSX}>
                          {p('exportEmployees')} (XLSX)
                        </DropdownItem>
                        <DropdownItem onClick={this.exportCompanies}>
                          {p('exportCompanies')} (CSV)
                        </DropdownItem>
                        <DropdownItem onClick={this.exportEmployees}>
                          {p('exportEmployees')} (CSV)
                        </DropdownItem>
                        <DropdownItem divider />
                        <DropdownItem tag={Link} to="/companies/create?tab=1">
                          {p('createCompany')}
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </div>
                </>
              }
              bodyClassName="form-card__body--flush"
              className="mb-3"
            >
              <Table responsive bordered className="table--roomy table--stack">
                <thead>
                  <tr>
                    <th
                      className="sortable"
                      onClick={() => this.handleSort('name')}
                    >
                      {s('name')}
                      <SortDirection
                        active={order === 'name'}
                        direction={reverse}
                      />
                    </th>
                    <th
                      className="sortable"
                      onClick={() => this.handleSort('employeeCount')}
                    >
                      {s('employees')}
                      <SortDirection
                        active={order === 'employeeCount'}
                        direction={reverse}
                      />
                    </th>
                    <th
                      className="sortable"
                      onClick={() => this.handleSort('companyCategories')}
                    >
                      {s('level')} / {s('category')}
                      <SortDirection
                        active={order === 'companyCategories'}
                        direction={reverse}
                      />
                    </th>
                    <th>
                      {s('sponsor')} / {s('visibleInApp')}
                    </th>
                    {this.state.sponsorViews.enabled && (
                      <th title={sv('viewersColumnInfo')}>
                        {sv('viewersColumn', {
                          month: this.state.sponsorViews.month
                            ? moment(
                                `${this.state.sponsorViews.month}-01`
                              ).format('MMM YYYY')
                            : '',
                        })}
                      </th>
                    )}
                    {this.state.sponsorViews.enabled && (
                      <th title={sv('clicksColumnInfo')}>
                        {sv('clicksColumn')}
                      </th>
                    )}
                    <th />
                  </tr>
                </thead>
                <tbody>{this.listCompanies()}</tbody>
              </Table>
            </FormCard>
            <Pagination
              items={this.state.companies.total}
              rowsPerPage={[25, 50, 100]}
              onChangePage={this.onChangePage}
            />
          </TabPane>
          <TabPane tabId="2">
            <ShareModal
              visible={levelModal.visible}
              handleModal={() => {
                this.closeSettingModal(SettingType.LEVEL);
                this.setState({
                  levelModal: {
                    visible: false,
                    levelState: null,
                    type: '',
                  },
                });
              }}
            >
              <LevelInformation
                selectedLevel={levelModal.levelState}
                type={levelModal.type}
                onSubmit={this.onSubmitSetting}
                updateSelectedCompanies={this.updateSelectedCompanies}
                handleModalTypeChangeToEdit={this.handleModalTypeChangeToEdit}
              />
            </ShareModal>
            <ShareModal
              visible={groupModal.visible}
              handleModal={() => {
                this.closeSettingModal(SettingType.GROUP);
                this.setState({
                  groupModal: {
                    visible: false,
                    groupState: null,
                    type: '',
                  },
                });
              }}
            >
              <GroupForm
                initialValues={{ name: groupModal?.groupState?.value }}
                type={SettingType.GROUP}
                settingState={groupModal.groupState}
                modalType={groupModal.type}
                onSubmit={this.onSubmitSetting}
                updateSelectedCompanies={this.updateSelectedCompanies}
                handleModalTypeChangeToEdit={this.handleModalTypeChangeToEdit}
              />
            </ShareModal>
            <div className="user-layout company-settings">
              <FormCard
                title={
                  <>
                    {s('levels')}
                    <span className="form-card__count">
                      {this.state.levels.length}
                    </span>
                  </>
                }
                actions={
                  <Button
                    onClick={() =>
                      this.setState({
                        levelModal: {
                          visible: true,
                          levelState: null,
                          type: 'create',
                        },
                      })
                    }
                    size="sm"
                    color="primary"
                    className="mb-0"
                  >
                    {p('createLevel')}
                  </Button>
                }
                bodyClassName="form-card__body--flush"
              >
                <p className="form-card__intro">{p('levelsHint')}</p>
                <DragDropContext onDragEnd={this.categoryOnDragEnd}>
                  <Table
                    responsive
                    striped
                    className="table--roomy table--stack mb-0"
                  >
                    <thead>
                      <tr>
                        <th className="table-col--drag" />
                        <th>{s('name')}</th>
                        <th>{s('companies')}</th>
                        <th />
                      </tr>
                    </thead>
                    <Droppable droppableId="level-dnd">
                      {(provided) => (
                        <tbody
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                        >
                          {this.renderLevels()}
                          {provided.placeholder}
                          {!this.state.levels.length && (
                            <tr>
                              <td colSpan={4} className="settings-empty">
                                {p('noLevels')}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      )}
                    </Droppable>
                  </Table>
                </DragDropContext>
              </FormCard>

              <FormCard
                title={
                  <>
                    {s('groups')}
                    <span className="form-card__count">
                      {this.state.groups.length}
                    </span>
                  </>
                }
                actions={
                  <Button
                    onClick={() =>
                      this.setState({
                        groupModal: {
                          visible: true,
                          groupState: null,
                          type: 'create',
                        },
                      })
                    }
                    size="sm"
                    color="primary"
                    className="mb-0"
                  >
                    {p('createGroup')}
                  </Button>
                }
                bodyClassName="form-card__body--flush"
              >
                <p className="form-card__intro">{p('groupsHint')}</p>
                <Table
                  responsive
                  striped
                  className="table--roomy table--stack mb-0"
                >
                  <thead>
                    <tr>
                      <th>{s('name')}</th>
                      <th>{s('companies')}</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    {this.renderGroups()}
                    {!this.state.groups.length && (
                      <tr>
                        <td colSpan={3} className="settings-empty">
                          {p('noGroups')}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </FormCard>
            </div>
          </TabPane>
          <TabPane tabId="3">
            <Row className="my-1">
              <Col md="12">
                <h3 className="page-title"> </h3>
              </Col>
            </Row>
            <Row className="my-1 mb-3">
              <Col md="12">
                <CompanyCategoryBreakdown />
                <CompanyLevelBreakdown />
              </Col>
            </Row>
          </TabPane>
          {(this.state.sponsorViews.enabled || this.props.isSuperAdmin) &&
            tab === '4' && (
              <TabPane tabId="4">
                {this.props.isSuperAdmin && (
                  <SponsorViewsClubSettings
                    clubId={this.props.clubConfig?.id}
                    onChanged={this.getSponsorViews}
                  />
                )}
                {this.state.sponsorViews.enabled && <SponsorViewsCard />}
              </TabPane>
            )}
        </TabContent>
      </Container>
    );
  }
}
const PageWithHock = (Page) => {
  const WrappedComponent = (props) => {
    const config = useConfig();
    const isSuperAdmin = useSelector((state) =>
      state.admin.me?.permissions?.includes('super-admin')
    );
    return <Page clubConfig={config} isSuperAdmin={isSuperAdmin} {...props} />;
  };

  return WrappedComponent;
};
export default withRouter(PageWithHock(CompanyListPage));
